import { Line } from 'react-chartjs-2';
import React from 'react';

const LineChart = React.memo(({ data }) => {
    const options = {
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };
    return (
        <>
            <Line data={data} options={options} redraw={true} />
        </>
    );
});

export default LineChart;
